module.exports = __webpack_public_path__ + "6fd443668acee0e9a8d0645b6d27ca47.pdf";